import { trackPromise } from 'react-promise-tracker';
import { useQuery } from 'react-query';
import { getRebuildImportTree } from '..';
export const useGetRebuildImportTree = (additionlInfo) => useQuery(['GetRebuildImportTree', additionlInfo], () => trackPromise(getRebuildImportTree(additionlInfo)), {
    cacheTime: 0
});
